/*
 * Mounted beside `PresenceHeartbeat`. Renders nothing; runs only while the
 * firm has time tracking turned on.
 */
import type { FC } from "react";
import { useSelector } from "react-redux";

import { lawyerSelectors } from "../../../redux/lawyer/selectors";
import type { LawyerReducer } from "../../../redux/lawyer/lawyerSlice";
import { useWorkTracker } from "./useWorkTracker";

export const WorkTracker: FC = () => {
  const enabled = useSelector((s: LawyerReducer) =>
    lawyerSelectors.selectTimeTrackingEnabled(s)
  );
  useWorkTracker(enabled);
  return null;
};
